import {getElement} from "../utils/getElement";
import {addClass} from "../utils/classnames";

const initContactForm = () => {
    const help = getElement('.js-help-support')

    if (!help) {
        return null;
    }

    const stepsContainer = getElement('.c-contact-form')

    help.addEventListener('click', () => {
        addClass(help, 'is-active')
        goToNextStep()
    })

    const goToNextStep = () => {
        addClass(stepsContainer, 'is-active')

        scrollToForm()
    }

    const scrollToForm = () => {
        getElement('.c-contact-form').scrollIntoView({behavior: 'smooth', block: 'start'});
    }
}

export {initContactForm}
